export * from './DeviceAlreadyReceived'


export default class CanonicalException {
  public code: string

  constructor(code: string) {
    this.code = code
  }
}